// extracted by mini-css-extract-plugin
export default {"radioContainer":"functionViewScreen_radioContainer__CaWVW","functionTabTitle":"functionViewScreen_functionTabTitle__P7ObT","grid":"functionViewScreen_grid__1zEU5"};